import { render, staticRenderFns } from "./costTypeDetail.vue?vue&type=template&id=6fcebdb0&scoped=true"
import script from "./costTypeDetail.vue?vue&type=script&lang=js"
export * from "./costTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./costTypeDetail.vue?vue&type=style&index=0&id=6fcebdb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcebdb0",
  null
  
)

export default component.exports